import { render } from "./firefoxGeneral.vue?vue&type=template&id=1dd3f5d2"
import script from "./firefoxGeneral.vue?vue&type=script&lang=js"
export * from "./firefoxGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__